<template>
    <div class="input-wrapper">

        <template v-if="type == 'textarea'">
                <textarea class='textarea' :name="name" :value="value" :placeholder="placeholder" @input="$emit('input', $event.target.value)"/>
        </template>

        <template v-if="type != 'checkbox' && type != 'radio' && type != 'submit' && type != 'textarea' && type != 'date'">
                <input class="input" :type="type" :name="name" :value="value" :placeholder="placeholder" :id="id" @input="$emit('input', $event.target.value)">
        </template>

        <template v-if="type == 'date'">
                <input class="input date" type="date" :name="name" :value="value" :placeholder="placeholder" :id="id" @input="$emit('input', $event.target.value)">
        </template>

        <template v-if="type == 'submit'">
                <input :type="type" :name="name" :value="value" :placeholder="placeholder" @input="$emit('input', $event.target.value)">
        </template>

        <template v-if="type == 'checkbox' || type == 'radio'">
            <label>
                <div class="checkbox">
                    <input :type="type"
                    :name="name"
                    :value="value" :placeholder="placeholder"
                    @change="onChange"
                    :checked="state"
                    :required="required">
                    <span class="checkbox--wrapper">
                    </span>
                </div>
                <div>
                    <slot></slot>
                </div>

            </label>
        </template>
    </div>

</template>


<script>

    export default {
        props: {
            type: {}, 
            name: {}, 
            value: {}, 
            reference: {},
            placeholder: {},
            id: {},
            checked: {
                type: Boolean,
                default: false,
            },
            model: {},
            required: {
                type: Boolean,
                default: false
            },
            modelValue: {
                default: undefined,
            },
        },
        name: 'stb-input',
        data () {
            return {
            }
        },
        model: {
            prop: 'modelValue',
            event: 'input'
        },

        computed: {
            state() {
                if (this.modelValue === undefined) {
                    return this.checked;
                }
                if (Array.isArray(this.modelValue)) {
                    return this.modelValue.indexOf(this.value) > -1;
                }
                return !!this.modelValue;
            }
        },

        methods: {
            onChange() {
                this.toggle();
            },
            toggle() {
                let value;
                if (Array.isArray(this.modelValue)) {
                    value = this.modelValue.slice(0);
                    if (this.state) {

                        value.splice(value.indexOf(this.value), 1);
                    } else {
                        value.push(this.value);
                    }
                } else {
                    value = !this.state;
                }
                this.$emit('input', value);
            }
        },

        watch: {
            checked(newValue) {
                if (newValue !== this.state) {
                    this.toggle();
                }
            }
        },
        mounted() {
            if (this.checked && !this.state) {
                this.toggle();
            }
        },
    }

</script>


<style scoped lang='scss'>

.input-wrapper {
    display: inline-block;
}

.input, .textarea {
    background-color: rgba(206, 216, 217, 0.28);
    display: inline-block;
    border: none;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    transition: all 0.2s;
    font-size: 1em;
    min-width: 17em;
    margin: 0pt;
    height: 24pt;
    padding: 0pt 8pt 0pt 8pt;
    color: #4B4F4F;
    font-weight: 300;
    outline: none;
}
.textarea {
    min-height: 8em;
}

label {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    width: 100%;
    cursor: pointer;
}

label .checkbox {
    width: 1.8em;
    min-width: 1.8em;
    text-align: left;
}

label input {
    opacity: 0;
    position: absolute;
    pointer-events: none;
    z-index: -1;
    width: 0.1px;
    height: 0.1px;
}

.checkbox--wrapper {
    width: 1em;
    height: 1em;
    display: inline-block;
    position: relative;
    border-radius: 100%;
    border: 2px solid $light-bg-color;
    margin-top: 0.2em;
}

.checkbox--wrapper:after {
    content: "";
    position: absolute;
    transform: rotate(45deg);
    height: 1em;
    top: -0.4em;
    left: 0.4em;
    width: 0.4em;
    border: 2px solid $darker-bg-color;
    border-top-width: 0px;
    border-left-width: 0px;
    display: none;
}

input:checked ~ .checkbox--wrapper:after {
    display: inline-block;
}


input[type=submit] {
    color: white;
    background-color: $primary-bg;
    padding: 0.4em 1em;
    display: inline-block;
    margin-right: 0.5em;
    margin-left: 0em;
    margin-top: 0.5em;
    transition: 0.1s ease-in-out;
}

input[type=submit]:hover {
    transform: translateY(-3px);
}

input[type=date]::-webkit-inner-spin-button, input[type=date]::-webkit-clear-button, input[type=date]::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
    display: none;
}

textarea {
    /*resize: none;*/
    outline: none;
}

textarea:focus{
    border: 2px solid rgba($darker-bg-color, 0.7);
}

</style>




// WEBPACK FOOTER //
// src/components/general/stbInput.vue